import {FilterDialogSectionId} from 'filters/features/FilterDialog/types';
import {assertPolicyFilter, isPolicyFilter} from 'filters/types';
import {FilterTopbarItemId} from 'filters/features/FilterTopbar/types';

import {createTreeViewSection} from 'filters/features/FilterDialog/sections/TreeViewSection/TreeViewSection';
import {useIndustryTree} from 'modules/decisionsNext/hooks/trees/useIndustryTree';
import {useIndustryTreeViewSelection} from 'features/GlobalFilterProvider/filters/industries/useIndustryTreeViewSelection';
import {openFilterDialog} from 'filters';
import {createCounterItem} from 'filters/features/FilterTopbar/items/CounterItem/CounterItem';

import IndustryIcon from 'components/icons/metrics/industries.svg';

export const industriesDialogSection = createTreeViewSection({
  id: FilterDialogSectionId.Industries,
  title: 'Industries',
  icon: IndustryIcon,
  useTreeData: useIndustryTree,
  getDataOptions: value => ({
    skip: Object.values(value.ids).every(ids => !ids?.length),
  }),
  useTreeSelection: useIndustryTreeViewSelection,
  getValue: filter => {
    assertPolicyFilter(filter);

    return {
      naicsScore: filter.naicsSourceConfidenceScore ?? null,
      ids: {
        industryGroupIds: filter.industryGroupIds ?? undefined,
        industrySubGroupIds: filter.industrySubGroupIds ?? undefined,
        industryIds: filter.industryIds ?? undefined,
      },
    };
  },
  onChange: (filter, value) => {
    assertPolicyFilter(filter);

    return {
      ...filter,
      naicsSourceConfidenceScore: value.naicsScore,
      industryGroupIds: value.ids.industryGroupIds,
      industrySubGroupIds: value.ids.industrySubGroupIds,
      industryIds: value.ids.industryIds,
    };
  },
});

export const industriesTopbarItems = [
  createCounterItem({
    id: FilterTopbarItemId.ConfidenceScore,
    entity: 'Confidence Score',
    getCount: filter => {
      if (!isPolicyFilter(filter)) {
        return;
      }

      return filter.naicsSourceConfidenceScore?.length;
    },
    onClick: () => openFilterDialog(FilterDialogSectionId.Industries),
    onReset: filter => {
      assertPolicyFilter(filter);

      return {
        ...filter,
        naicsSourceConfidenceScore: undefined,
      };
    },
  }),
  createCounterItem({
    id: FilterTopbarItemId.Industries,
    entity: 'Industries',
    getCount: filter => {
      if (!isPolicyFilter(filter)) {
        return;
      }

      return [filter.industryGroupIds, filter.industrySubGroupIds, filter.industryIds].reduce(
        (acc, ids) => acc + (ids?.length ?? 0),
        0
      );
    },
    onClick: () => openFilterDialog(FilterDialogSectionId.Industries),
    onReset: filter => {
      assertPolicyFilter(filter);

      return {
        ...filter,
        industryGroupIds: undefined,
        industrySubGroupIds: undefined,
        industryIds: undefined,
      };
    },
  }),
];
